import { createAction, props } from '@ngrx/store';
import { AccountInfo } from '../state/init.state';

export const getUser = createAction(
  '[Init] GET_USER_DETAILS_ON_LOAD',
  props<{ userId: number }>(),
);

export const getUserSuccess = createAction(
  '[Init] GET_USER_DETAILS_ON_LOAD_SUCCESS',
  props<{ accountInfo: AccountInfo }>(),
);

export const getUserError = createAction(
  '[Init] GET_USER_DETAILS_ON_LOAD_ERROR',
);
